module.exports = __webpack_public_path__ + "assets/img/price-hot.4f05d97a.png";